import { publicIpv4 } from "public-ip";

export const getIP = async () => {
    try {
      // Return the result of the publicIpv4 function directly
      return await publicIpv4();
    } catch (error) {
      // Handle any potential errors during the promise execution
      console.error(error);
      // Return an empty string or a default value if there is an error
      return "";
    }
  };
  